import React from "react";
import CustomTable from "../customTable";
import { ResultsPerListAndCampaignsColumns } from "./columns/ResultsPerListAndCampaignsColumns";
import Comments from "../comments";

// Define columns based on ResultsPerListAndCampaignsColumns
const ResultsPerListOnlyColumns = [
  { header: "List", accessor: "list" },
  // Use slice to get the columns after the 7th column from ResultsPerListAndCampaignsColumns
  ...(ResultsPerListAndCampaignsColumns ? ResultsPerListAndCampaignsColumns.slice(7) : []),
];

const ResultsPerListOnly = ({ processedData, loading }) => {

  return (
    <div className="d-flex flex-column gap-2">
      <CustomTable
        columns={ResultsPerListOnlyColumns}
        data={processedData?.results_per_list_only?.data || []}
        totalAggregatedData={processedData?.results_per_list_only?.totals || {}}
        loading={loading}
        storageKey={"resultsperlistonly"}
      />
      <Comments tab_name="Results per list only" />
    </div>
  );
};

export default ResultsPerListOnly;
